export default __webpack_public_path__ + "static/media/frame_ja_pc.d1113f07.png";